module.exports = __webpack_public_path__ + "img/logo.88a7d5e6.svg";